import React, { lazy, Suspense } from 'react'
/*
import ArcContext from 'pages/sports/ArcContext'
import AthContext from 'pages/sports/AthContext'
import BdmContext from 'pages/sports/BdmContext'
import BkbContext from 'pages/sports/BkbContext'
import BkgContext from 'pages/sports/BkgContext'
import Bk3Context from 'pages/sports/Bk3Context'
import BmfContext from 'pages/sports/BmfContext'
import BmxContext from 'pages/sports/BmxContext'
import BoxContext from 'pages/sports/BoxContext'
import BscContext from 'pages/sports/BscContext'
import BocContext from 'pages/sports/BocContext'
import ClbContext from 'pages/sports/ClbContext'
import CrdContext from 'pages/sports/CrdContext'
import CslContext from 'pages/sports/CslContext'
import CspContext from 'pages/sports/CspContext'
import CtrContext from 'pages/sports/CtrContext'
import DivContext from 'pages/sports/DivContext'
import EquContext from 'pages/sports/EquContext'
import FblContext from 'pages/sports/FblContext'
import FenContext from 'pages/sports/FenContext'

import GarContext from 'pages/sports/GarContext'
import GblContext from 'pages/sports/GblContext'
import GlfContext from 'pages/sports/GlfContext'

import GryContext from 'pages/sports/GryContext'
import GtrContext from 'pages/sports/GtrContext'
import HbbContext from 'pages/sports/HbbContext'
import HblContext from 'pages/sports/HblContext'
import HocContext from 'pages/sports/HocContext'
import JudContext from 'pages/sports/JudContext'
import KikContext from 'pages/sports/KikContext'
import KteContext from 'pages/sports/KteContext'
import MpnContext from 'pages/sports/MpnContext'
import MtbContext from 'pages/sports/MtbContext'
import MtiContext from 'pages/sports/MtiContext'
import OwsContext from 'pages/sports/OwsContext'


import PdlContext from 'pages/sports/PdlContext'
import PwlContext from 'pages/sports/PwlContext'
import RoiContext from 'pages/sports/RoiContext' //Invictus
import RowContext from 'pages/sports/RowContext'
import Ru7Context from 'pages/sports/Ru7Context'
import SalContext from 'pages/sports/SalContext'
import ShoContext from 'pages/sports/ShoContext' //Kracovia
import ShoContextOly from 'pages/sports/ShoContext _Oly' //Paris
import SjpContext from 'pages/sports/SjpContext'
import SkbContext from 'pages/sports/SkbContext'
import SrfContext from 'pages/sports/SrfContext'
import SwaContext from 'pages/sports/SwaContext'
import SwmContext from 'pages/sports/SwmContext'
import TenContext from 'pages/sports/TenContext'
import TeqContext from 'pages/sports/TeqContext'
import TkwContext from 'pages/sports/TkwContext'
import TriContext from 'pages/sports/TriContext'
//import TriContext_paras from 'pages/sports/TriContext_paras'
import TteContext from 'pages/sports/TteContext'
import VbvContext from 'pages/sports/VbvContext'
import VvoContext from 'pages/sports/VvoContext'
import WbkContext from 'pages/sports/WbkContext'
import WfeContext from 'pages/sports/WfeContext'
import WlfContext from 'pages/sports//WlfContext'
import WpoContext from 'pages/sports//WpoContext'
import WreContext from 'pages/sports/WreContext'
import WruContext from 'pages/sports/WruContext'

*/



import { useUrlFriendlyToParameters } from 'helpers/urlFriendly'
import Loader from 'components/general/Loader';




const ArcContext = lazy(() => import('pages/sports/ArcContext'));
const AthContext = lazy(() => import('pages/sports/AthContext'));
const BdmContext = lazy(() => import('pages/sports/BdmContext'));
const BkbContext = lazy(() => import('pages/sports/BkbContext'));
const BkgContext = lazy(() => import('pages/sports/BkgContext'));
const Bk3Context = lazy(() => import('pages/sports/Bk3Context'));
const BmfContext = lazy(() => import('pages/sports/BmfContext'));
const BmxContext = lazy(() => import('pages/sports/BmxContext'));
const BoxContext = lazy(() => import('pages/sports/BoxContext'));
const BscContext = lazy(() => import('pages/sports/BscContext'));
const BocContext = lazy(() => import('pages/sports/BocContext'));
const ClbContext = lazy(() => import('pages/sports/ClbContext'));
const CrdContext = lazy(() => import('pages/sports/CrdContext'));
const CslContext = lazy(() => import('pages/sports/CslContext'));
const CspContext = lazy(() => import('pages/sports/CspContext'));
const CtrContext = lazy(() => import('pages/sports/CtrContext'));
const DivContext = lazy(() => import('pages/sports/DivContext'));
const EquContext = lazy(() => import('pages/sports/EquContext'));
const FblContext = lazy(() => import('pages/sports/FblContext'));
const FenContext = lazy(() => import('pages/sports/FenContext'));
const GarContext = lazy(() => import('pages/sports/GarContext'));
const GblContext = lazy(() => import('pages/sports/GblContext'));
const GlfContext = lazy(() => import('pages/sports/GlfContext'));
const GryContext = lazy(() => import('pages/sports/GryContext'));
const GtrContext = lazy(() => import('pages/sports/GtrContext'));
const HbbContext = lazy(() => import('pages/sports/HbbContext'));
const HblContext = lazy(() => import('pages/sports/HblContext'));
const HocContext = lazy(() => import('pages/sports/HocContext'));
const JudContext = lazy(() => import('pages/sports/JudContext'));
const KikContext = lazy(() => import('pages/sports/KikContext'));
const KteContext = lazy(() => import('pages/sports/KteContext'));
const MpnContext = lazy(() => import('pages/sports/MpnContext'));
const MtbContext = lazy(() => import('pages/sports/MtbContext'));
const MtiContext = lazy(() => import('pages/sports/MtiContext'));
const OwsContext = lazy(() => import('pages/sports/OwsContext'));
const PdlContext = lazy(() => import('pages/sports/PdlContext'));
const PwlContext = lazy(() => import('pages/sports/PwlContext'));
const RoiContext = lazy(() => import('pages/sports/RoiContext'));
const RowContext = lazy(() => import('pages/sports/RowContext'));
const Ru7Context = lazy(() => import('pages/sports/Ru7Context'));
const SalContext = lazy(() => import('pages/sports/SalContext'));
const ShoContext = lazy(() => import('pages/sports/ShoContext'));
const ShoContextOly = lazy(() => import('pages/sports/ShoContext _Oly'));
const SjpContext = lazy(() => import('pages/sports/SjpContext'));
const SkbContext = lazy(() => import('pages/sports/SkbContext'));
const SrfContext = lazy(() => import('pages/sports/SrfContext'));
const SwaContext = lazy(() => import('pages/sports/SwaContext'));
const SwmContext = lazy(() => import('pages/sports/SwmContext'));
const TenContext = lazy(() => import('pages/sports/TenContext'));
const TeqContext = lazy(() => import('pages/sports/TeqContext'));
const TkwContext = lazy(() => import('pages/sports/TkwContext'));
const TriContext = lazy(() => import('pages/sports/TriContext'));
const TteContext = lazy(() => import('pages/sports/TteContext'));
const VbvContext = lazy(() => import('pages/sports/VbvContext'));
const VvoContext = lazy(() => import('pages/sports/VvoContext'));
const WbkContext = lazy(() => import('pages/sports/WbkContext'));
const WfeContext = lazy(() => import('pages/sports/WfeContext'));
const WlfContext = lazy(() => import('pages/sports/WlfContext'));
const WpoContext = lazy(() => import('pages/sports/WpoContext'));
const WreContext = lazy(() => import('pages/sports/WreContext'));
const WruContext = lazy(() => import('pages/sports/WruContext'));


export function Results() {
    const { mirs_discipline, mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
    let out = null
    switch (mirs_discipline) {
        case 'ARC':
            out = <ArcContext key={mirs_rsc} />
            break;
        case 'ATH':
            out = <AthContext key={mirs_rsc} />
            break;
        case 'BDM':
            out = <BdmContext key={mirs_rsc} />
            break;
        case 'BKB':
            out = <BkbContext key={mirs_rsc} />
            break;
        case 'BKG':
            out = <BkgContext key={mirs_rsc} />
            break;
        case 'BK3':
            out = <Bk3Context key={mirs_rsc} />
            break;
        case 'BMF':
            out = <BmfContext key={mirs_rsc} />
            break;
        case 'BMX':
            out = <BmxContext key={mirs_rsc} />
            break;
        case 'BOX':
            out = <BoxContext key={mirs_rsc} />
            break;
        case 'BOC':
            out = <BocContext key={mirs_rsc} />
            break;
        case 'BSC':
            out = <BscContext key={mirs_rsc} />
            break;
        case 'CLB':
            out = <ClbContext key={mirs_rsc} />
            break;
        case 'CRD':
            out = <CrdContext key={mirs_rsc} />
            break;
        case 'CSL':
            out = <CslContext key={mirs_rsc} />
            break;
        case 'CSP':
            out = <CspContext key={mirs_rsc} />
            break;
        case 'CTR':
            out = <CtrContext key={mirs_rsc} />
            break;
        case 'DIV':
            out = <DivContext key={mirs_rsc} />
            break;
        case 'EQU':
            out = <EquContext key={mirs_rsc} />
            break;
        case 'FBB':
        case 'FBL':
            out = <FblContext key={mirs_rsc} />
            break;
        case 'FEN':
        case 'WFE':
            out = <FenContext key={mirs_rsc} />
            break;
        case 'GAR':
            out = <GarContext key={mirs_rsc} />
            break;
        case 'GBL':
            out = <GblContext key={mirs_rsc} />
            break;
        case 'GLF':
            out = <GlfContext key={mirs_rsc} />
            break;
        case 'GRY':
            out = <GryContext key={mirs_rsc} />
            break;
        case 'GTR':
            out = <GtrContext key={mirs_rsc} />
            break;
        case 'HBL':
            out = <HblContext key={mirs_rsc} />
            break;
        case 'HBB':
            out = <HbbContext key={mirs_rsc} />
            break;
        case 'HOC':
            out = <HocContext key={mirs_rsc} />
            break;
        case 'JUD':
            out = <JudContext key={mirs_rsc} />
            break;
        case 'KIK':
            out = <KikContext key={mirs_rsc} />
            break;
        case 'KTE':
            out = <KteContext key={mirs_rsc} />
            break;
        case 'MPN':
            out = <MpnContext key={mirs_rsc} />
            break;
        case 'MTB':
            out = <MtbContext key={mirs_rsc} />
            break;
        case 'MTI':
            out = <MtiContext key={mirs_rsc} />
            break;
        case 'OWS':
            out = <OwsContext key={mirs_rsc} />
            break;
        case 'PDL':
            out = <PdlContext key={mirs_rsc} />
            break;
        case 'PWL':
            out = <PwlContext key={mirs_rsc} />
            break;
        case 'ROI':
            out = <RoiContext key={mirs_rsc} />
            break;
        case 'ROW':
            out = <RowContext key={mirs_rsc} />
            break;
        case 'TKW':
            out = <TkwContext key={mirs_rsc} />
            break;
        case 'TRI':
            if (mirs_competition === 'PG2024') {
                out = <TriContext key={mirs_rsc} />
            } else {
                out = <TriContext key={mirs_rsc} />
            }
            break;
        case 'RU7':
            out = <Ru7Context key={mirs_rsc} />
            break;
        case 'SAL':
            out = <SalContext key={mirs_rsc} />
            break;
        case 'SHO':
            if (mirs_competition === 'EG2023') {
                out = <ShoContext key={mirs_rsc} />
            } else {
                out = <ShoContextOly key={mirs_rsc} />
            }

            break;
        case 'SJP':
            out = <SjpContext key={mirs_rsc} />
            break;
        case 'SRF':
            out = <SrfContext key={mirs_rsc} />
            break;
        case 'SKB':
            out = <SkbContext key={mirs_rsc} />
            break;
        case 'SWA':
            out = <SwaContext key={mirs_rsc} />
            break;
        case 'SWM':
            out = <SwmContext key={mirs_rsc} />
            break;
        case 'WTE':
        case 'TEN':
            out = <TenContext key={mirs_rsc} />
            break;
        case 'TEQ':
            out = <TeqContext key={mirs_rsc} />
            break;
        case 'TTE':
            out = <TteContext key={mirs_rsc} />
            break;
        case 'VBV':
            out = <VbvContext key={mirs_rsc} />
            break;
        case 'VBS':
        case 'VVO':
            out = <VvoContext key={mirs_rsc} />
            break;
        case 'WBK':
            out = <WbkContext key={mirs_rsc} />
            break;
        /* case 'WFE':
            out = <WfeContext key={mirs_rsc} />
            break; */
        case 'WLF':
            out = <WlfContext key={mirs_rsc} />
            break;
        case 'WPO':
            out = <WpoContext key={mirs_rsc} />
            break;
        case 'WRE':
            out = <WreContext key={mirs_rsc} />
            break;
        case 'WRU':
            out = <WruContext key={mirs_rsc} />
            break;
        default:
            out = <div>Discipline not delivered</div>
    }

    return (
        <section id={`mirs-result-page-${mirs_rsc}`}>
            <Suspense fallback={<Loader />}>
                {out}
            </Suspense>
        </section>
    )
}

export default Results
